import React, { useState, useEffect } from "react";
import { TiMinus, TiPlus } from "react-icons/ti";
import { getUserCredentials } from "../../../api/usuarioApi";
import { getAdminById } from "../../../api/AdminApi";
import CajaEntrada from "./CajaEntrada";
import CajaSalida from "./CajaSalida";
import Stock from "./Stock";
import "../opciones/Opciones.css";

export default function Inventario() {
  const [showEntrada, setShowEntrada] = useState(true);
  const [showSalida, setShowSalida] = useState(false);
  const [showStock, setShowStock] = useState(false);

  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);

  const [stockRefresh, setStockRefresh] = useState(false);

  const refreshStock = () => setStockRefresh((p) => !p);

  useEffect(() => {
    const checkPermission = async () => {
      setLoading(true);
      try {
        const resultUser = await getUserCredentials();
        const USERDATA = await getAdminById(resultUser.IdUsuario);
        const admin = USERDATA?.[0];

        if (!admin) { setHasPermission(false); return; }

        const tieneCierres = admin.cierres === "true";
        const tieneSesiones = admin.sesiones === "true";
        const tieneOpciones = admin.opciones === "true";

        if (tieneCierres || tieneSesiones || tieneOpciones) {
          setHasPermission(true);
        } else {
          setHasPermission(false);
        }
      } catch (e) {
        console.error("Error al verificar permisos:", e);
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermission();
  }, []);

  if (loading) {
    return (
      <div style={{ minHeight: "60vh", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ width: 38, height: 38, border: "4px solid #ddd", borderTop: "4px solid #1569c9ff", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>Cargando...</span>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (hasPermission === false) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <h3>No tiene permisos para ver esta información.</h3>
      </div>
    );
  }

  if (hasPermission !== true) return null;

  const SectionHeader = ({ title, open, onToggle }) => (
    <div className="col-12 mt-2">
      <h4 className="card-title mb-0 d-flex align-items-center justify-content-between">
        <span>{title}</span>
        <button
          type="button"
          className="btn btn-light btn-sm"
          onClick={onToggle}
          style={{ border: "none", background: "none", boxShadow: "none" }}
        >
          {open ? <TiMinus size={24} /> : <TiPlus size={24} />}
        </button>
      </h4>
      <hr className="mt-1 mb-2" />
    </div>
  );

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title">Gestión de Inventario</h4>
      </div>
      <div className="card-body">

        {/* ─── CAJA DE ENTRADA ─────────────────────────────────── */}
        <SectionHeader
          title="Caja de Entrada"
          open={showEntrada}
          onToggle={() => setShowEntrada(!showEntrada)}
        />
        {showEntrada && <CajaEntrada onSaved={refreshStock} />}

        {/* ─── CAJA DE SALIDA ──────────────────────────────────── */}
        <SectionHeader
          title="Caja de Salida"
          open={showSalida}
          onToggle={() => setShowSalida(!showSalida)}
        />
        {showSalida && <CajaSalida onSaved={refreshStock} />}

        {/* ─── STOCK ───────────────────────────────────────────── */}
        <SectionHeader
          title="Stock"
          open={showStock}
          onToggle={() => {
            setShowStock(!showStock);
            if (!showStock) refreshStock();
          }}
        />
        {showStock && <Stock refreshTrigger={stockRefresh} />}

      </div>
    </div>
  );
}
